export const SCREEN_LOGIN = 'Login';
export const SCREEN_TOP = 'Top';
export const SCREEN_HOME = 'home';
export const SCREEN_BASIC_INFO = 'Basic Info';
export const SCREEN_BASIC_INFO_EDIT = 'Basic Info Edit';
export const SCREEN_BASIC_INFO_EDIT_CONFIRM = 'Basic Info Edit Confirm';
export const SCREEN_NO_AUTH = [
  'Login',
  'Forgot Password',
  'Top',
  'Reset Mail Complete',
  'Reset Mail Complete',
  'Reset password',
  'Reset password Complete',
  'Reset password Failure',
  'Verify Forgot Password',
  'Register term',
  'Register info',
  'Register info confirm',
  'Register confirm-mail send',
  'Register temporary complete',
  'Verify Register',
  'Register Failure',
  'Inquiry',
  'Inquiry Confirm',
  'Inquiry Complete',
  'News',
  'Register mfk Failure',
  'TopDetail',
];
export const SCREEN_NO_AUTH_FOOTER = [
  'Login',
  'Forgot Password',
  'Top',
  'Reset Mail Complete',
  'Reset Mail Complete',
  'Reset password',
  'Reset password Complete',
  'Reset password Failure',
  'Verify Forgot Password',
  'Register term',
  'Register info',
  'Register info confirm',
  'Register confirm-mail send',
  'Register temporary complete',
  'Verify Register',
  'Register Failure',
  'Inquiry',
  'Inquiry Confirm',
  'Inquiry Complete',
  'News',
  'NewsDetail',
  'OperatingCompany',
  'Privacy Policy',
  'Term Of Service',
  'Site Map',
  'FAQ List',
  'TopDetail',
  'Other page Link',
  'Riche Partners',
];
export const SCREEN_NO_AUTH_AND_AUTH = ['Inquiry', 'Inquiry Confirm', 'Inquiry Complete', 'News'];
export const SCREEN_RESET_PASSWORD_FAILURE = 'Reset password Failure';
export const REGISTER_TEMPORARY_COMPLETE = 'Register temporary complete';
export const REGISTER_CONFIRM_MAIL_SEND = 'Register confirm-mail send';
export const REGISTER_INFO = 'Register info';
export const REGISTER_INFO_CONFIRM = 'Register info confirm';
export const REGISTER_TERM = 'Register term';
export const REGISTER_FAILURE = 'Register Failure';
export const REGISTER_MFK_FAILURE = 'Register mfk Failure';
export const WATCH_LIST = 'ListBiddingWatch';
export const BID_LIST = 'ListBiddingBid';
export const WON_BID_LIST = 'ListBiddingWonBid';
export const EXHIBITION_LIST = 'ListBiddingExhibition';
export const ESTATE_DETAIL = 'Estate Detail';
export const ESTATE_HISTORY = 'EstateBidHistory';
export const ESTATE_DETAIL_SELLER = 'EstateDetailSeller';
export const ESTATE_CREATE_TERM = 'EstateCreateTerm';
export const SEARCH_RESULT = 'SearchResult';
export const SEARCH_BY_ADDRESS = 'SearchByAddress';
export const SEARCH_BY_TRAIN_LINE = 'SearchByTrainLine';
export const SEARCH_BY_TRAIN_LINE_STATION = 'SearchByTrainLineStation';
export const SCREEN_RESET_PASSWORD_COMPLETE = 'Reset password Complete';
export const SCREEN_RESET_PASSWORD = 'Reset password';
export const INQUIRY = 'Inquiry';
export const INQUIRY_CONFIRM = 'Inquiry Confirm';
export const INQUIRY_COMPLETE = 'Inquiry Complete';
export const MAINTENANCE = 'Maintenance';
export const SCREEN_ADV_OPTION = 'Advertising Option';
export const SCREEN_ADV_SELECT_OPTION = 'Advertising Option Select';
export const SCREEN_ADV_FRAME_SELECT = 'Advertising Option Frame Select';
export const ESTATE_DETAIL_SELLER_BID_HISTORY = 'EstateDetailSellerBidHistory';
export const ESTATE_RE_EXHIBIT = 'EstateExhibitSeller';
export const ESTATE_RE_EXHIBIT_CONFIRM = 'ReExhibitConfirm';

// u6-1
export const BIDDING_LIST_WATCH = 'ListBiddingWatch';
// u6-2
export const BIDDING_LIST_BID = 'ListBiddingBid';
// u6-3
export const BIDDING_LIST_WON = 'ListBiddingWonBid';
// u6-4
export const BIDDING_LIST_EXHIBITION = 'ListBiddingExhibition';

// 7-4
export const BID_CONFIRM_COMMON = 'EstateInfoBidConfirmCommon';
// 7-5
export const BID_CONFIRM_IMMEDIATE = 'EstateInfoBidConfirmImmediate';
// 7-6
export const BID_CONFIRM_ONETIME = 'EstateInfoBidConfirmOnetime';
// 7-7
export const BID_COMPLETE_COMMON = 'EstateInfoBidCompleteCommon';
// 7-8
export const BID_COMPLETE_IMMEDIATE = 'EstateInfoBidCompleteImmediate';

export const MESSAGE = 'Message';

export const SCREEN_TOP_AND_TOP_DETAIL = ['Top', 'TopDetail', 'Login'];

export const SCREEN_SHOW_BANNER_CAMPAIGN = ['Register info', 'Register info confirm'];
